import React, {useMemo} from "react";
import {inject, observer} from "mobx-react";
import {useTranslation} from "react-i18next";
//local
import {IconPhone, IconDocumentList} from "components/icons";
import {InitialsBadge} from "components/InitialsBadge";
import {RichField} from "components/RichField";
import {TitleIcon} from "components/TitleIcon";
import {getFullName} from "helpers/helper";
import ButtonPrint from "components/buttons/ButtonPrint";

const RequestCard = inject("store")(
  observer(({store: {buyer}}) => {
    const {currentRequest} = buyer;
    const {t} = useTranslation();
    const currentBuyer = useMemo(() => currentRequest?.ContactPerson, [currentRequest]);

    const buyerFullName = getFullName(currentBuyer?.firstName, currentBuyer?.lastName);
    const buyerPhone = currentBuyer?.mobilePhone ?? "none";
    const printPageTitle = `${currentRequest?.Project?.name}・${currentRequest?.name}.pdf`;

    return (
      <div className="request-view-block pos-r">
        <ButtonPrint
          infoTooltip="PRINT_OFFER_BUTTON_INFO_TOOLTIP"
          printTitle={printPageTitle}
          top="-20px"
          right="0px"
        />
        <TitleIcon title={t("DESCRIPTION")} icon={<IconDocumentList />} addClass="mt-4" />
        <RichField
          data={currentRequest.description || "---"}
          viewMode
          importType="html"
        />
        <div className="request-view-block_contacts pt-8">
          <span className="request-view-block_contacts_title __uppercase mr-8">
            {t("CONTACT")}:
          </span>
          <InitialsBadge
            firstName={currentBuyer?.firstName}
            lastName={currentBuyer?.lastName}
            addClass="mr-2"
          />
          <span className="mr-4">{buyerFullName || "Not found"}</span>
          <IconPhone height="15" width="15" />
          <span className="ml-2">{buyerPhone}</span>
        </div>
      </div>
    );
  })
);

export default RequestCard;
